"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TenantPicker = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var _react = require("@fluentui/react");

var _Panel = require("@fluentui/react/lib/components/Panel");

var _DetailsList = require("@fluentui/react/lib/DetailsList");

var _Persona = require("@fluentui/react/lib/Persona");

var React = _interopRequireWildcard(require("react"));

var _stylingConstants = require("../../styling/stylingConstants");

var cardStyles = require('../../styling/patterns/Card.scoped.scss');

var optionsStyles = require('../../styling/patterns/Section.scoped.scss');
/**
 * Picks an tenant/organization.
 */


var TenantPicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TenantPicker, _React$Component);

  var _super = (0, _createSuper2.default)(TenantPicker);

  function TenantPicker() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, TenantPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this.onRenderItem = function (item, _index, _column) {
      if (item === undefined) {
        return null;
      }

      var onClick = function onClick() {
        return _this.props.onChange && _this.props.onChange(item);
      };

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Persona.Persona, {
        size: _Persona.PersonaSize.small,
        text: item.text,
        onClick: onClick
      });
    };

    return _this;
  }

  (0, _createClass2.default)(TenantPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          close = _this$props.close,
          t = _this$props.t,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppPanel.AppPanel, {
        isOpen: isOpen,
        type: _Panel.PanelType.smallFixedFar,
        onDismiss: close,
        headerText: t('Organizations'),
        closeButtonAriaLabel: t('Close'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: optionsStyles.section,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Label, {
            children: t('Switch organizations')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: cardStyles.card,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DetailsList.DetailsList, {
              checkboxVisibility: _DetailsList.CheckboxVisibility.hidden,
              isHeaderVisible: false,
              onItemInvoked: this.props.onChange,
              columns: [{
                key: 'tenant',
                name: t('Organization'),
                fieldName: 'text',
                minWidth: _stylingConstants.gridUnit * 25,
                isPadded: false,
                onRender: this.onRenderItem
              }],
              items: options,
              getKey: TenantPicker.getItemKey
            })
          })]
        })
      });
    }
  }], [{
    key: "getItemKey",
    value: function getItemKey(item, index) {
      return item && item.key || (index !== undefined ? index.toString() : '');
    }
  }]);
  return TenantPicker;
}(React.Component);

exports.TenantPicker = TenantPicker;